module.exports = __webpack_public_path__ + "static/media/people.b3e33537.png";